export const ecpayErrorMessageMap: Record<string, string> = {
    ECPAY_MERCHANT_NOT_CONFIGURED: "w_TranslationJobTopupPayuniNotConfigured",
    ECPAY_AMOUNT_INVALID: "w_TranslationJobTopupAmountInvalid",
    ECPAY_ORG_NOT_FOUND: "w_TranslationJobTopupOrgNotFound",
    ECPAY_WALLET_NOT_FOUND: "w_TranslationJobTopupWalletNotFound",
    ECPAY_CHECKMAC_INVALID: "w_TranslationJobTopupPayuniHashInvalid",
    ECPAY_MERCHANT_MISMATCH: "w_TranslationJobTopupPayuniRequestFailed",
    ECPAY_NOTIFY_INVALID: "w_TranslationJobTopupPayuniResponseInvalid",
};

export const ecpayFallbackKey = "w_TranslationJobTopupPayuniFailed";

